export function withDocumentBody<V>(f: (body: HTMLElement) => V): V {
  if (document.body) {
    return f(document.body);
  }
  throw new Error('document.body not present');
}

export function withDocumentHead<V>(f: (head: HTMLElement) => V): V {
  if (document.head) {
    return f(document.head);
  }
  throw new Error('document.head not present');
}
